import React, { useState } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import AthleteAttendance from 'components/admin/reports/AthleteAttendance';
import { exportAthleteAttendanceReportToFile } from 'api/reportsApi';
import { useSelector } from 'react-redux';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import { exportAndDownloadFile } from 'utils/fileDownload';

const AthleteAttendancePage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [reportData, setReportData] = useState(null);

  const handleExportToFile = async () => {
    await exportAndDownloadFile(
      exportAthleteAttendanceReportToFile,
      [selectedClub.clubID],
      '',
      'The athlete attendance report was successfully exported',
      'Fetching athlete attendance data from the server...'
    );
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  return (
    <>
      <MetaTags title="SplitFast | Athlete Attendance Report" />
      <MainContent>
        <PageHeader
          title="Athlete Attendance Report"
          subTitle={reportData?.seasonName || ''}
          primarySubTitle
        >
          <CustomNewButton
            variant="info"
            onClick={handleExportToFile}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>
        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <AthleteAttendance
            clubID={selectedClub?.clubID}
            onDataChange={setReportData}
          />
        )}
      </MainContent>
    </>
  );
};

export default AthleteAttendancePage;
